export default "{\n    \"label\": \"Activo\",\n    \"placeholder\": \"Seleccione un activo\"\n}\n"